/* src/app/shared/materials-modal/materials-modal.component.scss */
.section-title {
  font-weight: 600;
}
.border-bottom {
  border-bottom: 2px solid var(--ion-color-primary);
  margin-left: -5px;
}
/*# sourceMappingURL=materials-modal.component.css.map */
